<template xmlns="http://www.w3.org/1999/html">
  <div class="shengsheng-page">
    <!-- 顶部整宽的酒图片 -->
    <img
      class="jiu-img"
      src="/static/images/shengsheng/jiu.png"
      alt="酒背景"
    >
    
    <!-- 蒙版层 -->
    <div class="overlay"></div>
    
    <!-- 活动规则容器 -->
    <div class="rules-container">
      <div class="rules-content" v-html="activityRule">
      </div>
    </div>
  </div>
</template>

<style scoped>
.shengsheng-page {
  position: relative;
  width: 100vw;
  min-height: 100vh;
  /* 用 bg.png 做全屏背景 */
  background: url("/static/images/shengsheng/bg.png") no-repeat center top;
  background-size: cover;
  overflow: hidden;
}

.jiu-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  display: block;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(184, 134, 81, 0.9);
  z-index: 9;
}

.rules-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90vw;
  height: 90vh;
  background-color: transparent;
  padding: 20px;
  overflow-y: auto;
  z-index: 10;
}

.rules-content {
  font-size: 12px;
  line-height: 1.5;
  color: #000;
}

.rules-content h3 {
  font-size: 14px;
  font-weight: bold;
  margin-top: 15px;
  margin-bottom: 10px;
  color: #000;
}

.rules-content p {
  margin-bottom: 8px;
}
</style>

<script>
import { getTemplate } from '../../api/api'

export default {
  data() {
    return {
      deptId: '', // 部门ID
      activityRule: '' // 活动规则内容
    };
  },
  mounted() {
    // 获取URL参数中的deptId
    this.deptId = this.$route.query.deptId || '';
    
    // 调用getTemplate方法
    if (this.deptId) {
      this.getTemplate();
    }
  },
  methods: {
    async getTemplate() {
      try {
        const res = await getTemplate(this.deptId);
        if (res.data.code === "200" && res.data.data != null) {
          // 获取活动规则内容
          this.activityRule = res.data.data.activityRule || '';
          console.log('Rule页面获取活动模板成功:', res.data.data);
        } else {
          console.log('Rule页面暂无可参与的活动');
        }
      } catch (error) {
        console.error('Rule页面获取模板失败:', error);
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/ShengSheng/Rule.vue